import { Button, ButtonProps } from '@cast/design-system';
import { K8sProvider } from '@cast/shared-types';

import { useOnboardClusterDialog } from 'hooks/dialogs';

type OnboardClusterButtonProps = Omit<ButtonProps, 'onClick'> & {
  initialProvider?: K8sProvider;
  initialAnywhereClusterName?: string;
};

export const OnboardClusterButton = ({
  initialProvider,
  initialAnywhereClusterName,
  ...props
}: OnboardClusterButtonProps) => {
  const { openOnboardClusterDialog, isLoading } = useOnboardClusterDialog({
    initialProvider,
    initialAnywhereClusterName,
  });
  return (
    <Button
      testId={isLoading ? undefined : 'connect-cluster-button'}
      {...props}
      onClick={() => openOnboardClusterDialog()}
    />
  );
};
